export default __webpack_public_path__ + "static/media/headshot-bharat-rai.b0c0c957.jpg";